import React from 'react';
import ViewReverse from '../../../components/ViewReverse';
import { formSteps } from '../../../config/config';
import { ReactSVG } from 'react-svg';
import { Text } from '../../../components/SecondaryMarket';
import { cn } from '../../../utils/utils';

const FormSteps = ({ getContentKey, step, setStep, formsPercentage }) => {
  return (
    <ViewReverse className='pt-8 bg-dark-blue w-full gap-6 overflow-x-auto justify-between 2xl:justify-center px-[5%]'>
      {formSteps.map((item, index) => {
        const active = step === item?.id;
        const isComplete = item?.progress_key && Math.round(formsPercentage?.[item.progress_key]?.progress ?? 0) >= 100;
        return (
          <React.Fragment key={item?.id || index}>
            <div className='flex flex-col items-center flex-1 2xl:min-w-[90px] 2xl:max-w-[90px] gap-4 cursor-pointer' onClick={() => setStep(item?.id)}>
              <div className={cn('relative', isComplete && '[&_[stroke-dasharray]]:[stroke-dasharray:none]')}>
                <ReactSVG src={active || isComplete ? item?.active_icon : item?.icon} />
                {isComplete && (
                  <svg className='absolute -top-1 -end-1' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                    <circle cx='10' cy='10' r='10' fill='#B4A085' />
                    <path d='M5.5 10.5L8.5 13.5L14.5 7' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                )}
              </div>
              <Text text={getContentKey(item?.name)} className={cn('flex-1', active || isComplete ? 'text-primary-light' : 'text-white/60')} align={'text-center'} />

              <div className={cn('w-full h-2', active ? 'bg-primary-light' : 'bg-transparent')} />
            </div>
            {index !== formSteps?.length - 1 && <div className='h-16 min-w-0.5 bg-white/40' />}
          </React.Fragment>
        );
      })}
    </ViewReverse>
  );
};

export default FormSteps;
